import script from "./CreditCalculator.vue?vue&type=script&setup=true&lang=js"
export * from "./CreditCalculator.vue?vue&type=script&setup=true&lang=js"

import "./CreditCalculator.vue?vue&type=style&index=0&id=705b0136&lang=css"

const __exports__ = script;

export default __exports__